export default function normalizedSearchString(string = "") {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
}